import { render, staticRenderFns } from "./helpList.vue?vue&type=template&id=68602083&scoped=true"
import script from "./helpList.vue?vue&type=script&lang=js"
export * from "./helpList.vue?vue&type=script&lang=js"
import style0 from "./helpList.vue?vue&type=style&index=0&id=68602083&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68602083",
  null
  
)

export default component.exports